<template>
    <div class="FoldingSandard">
        <Title firstName="能耗同环比" lastName="SAME CYCLE RATIO" />
        <div class="echarts">
            <div class="tab">
                <div :class="tabIdx == 0?'report se':'report'" @click="tabTitle(0)">能耗同比</div>
                <div :class="tabIdx == 1?'report se':'report'" @click="tabTitle(1)">能耗环比</div>
            </div>
            
            <div class="charts" v-show="$store.state.nav == 'energy' && tabIdx == 0">
                <div id="EnergyChain"  style="height: 16vh; width: 20vw;margin-top:-2vh" />
            </div>
            <div class="charts" v-show="$store.state.nav == 'energy' && tabIdx == 1">
                <div id="EnergyRatio"  style="height: 16vh; width: 20vw;margin-top:-2vh" />
            </div>
            <div class="tabdate">
                <div :class="dateIdx == 0?'report se':'report'" @click="tabdate(0)">用电</div>
                <div :class="dateIdx == 1?'report se':'report'"  @click="tabdate(1)">用水</div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import * as echarts from "echarts";
const Title = () => import('../../../../components/title/Title')
const SelectList = () => import('../../../../components/title/selectList.vue')
const Bar = () => import('../../../../components/echarts/bar.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const Graph = () => import('../../../../components/echarts/graph.vue')
import { getSevenDays, getMonthTime, getMonthDays, getTodayTime  } from "../../../../utils/common/index";

export default {
    data(){
        return {
            chartId:'EnergyAnalysisener',
            myChart:null,
            myChartHuan:null,
            xData:[],
            seriesOption:[],
            tabIdx:0,  // 切换种类
            dateIdx:0,
            // 同比的option
            option : {
                title: {
                    text: 'kWh',
                    x: '2%',
                    y: '-3%',
                    textStyle:{                  //标题样式
                        fontSize: '12',
                        fontFamily:'Source Han Sans CN',
                        color:'rgba(230,243,253, 0.7)',
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(0, 10, 26, 0.8)',
                    borderRadius: 8,  
                    borderWidth: 0,
                    shadowColor:'rgba(13, 148, 255, 0.8)',
                    axisPointer: {// 坐标轴指示器，坐标轴触发有效
                    type: 'line', // 默认为直线，可选为：'line' | 'shadow'
                    },
                    textStyle: {
                        color: '#fff'
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '1%',
                    top:'13%',
                    containLabel: true
                },
                legend: {
                    icon: "roundRect",
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: {
                        fontSize: 14,
                        color:"#f0f0f0"
                    },
                },
                xAxis: [
                {
                    type: 'category',
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    axisPointer: {
                    type: 'shadow'
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#f0f0f0",
                        },
                    },
                }
                ],
                yAxis: [
                {
                    type: 'value',
                    // name:'kgce',
                    min: 0,
                    // max: 250,
                    // interval: 50,
                    axisLabel: {
                    formatter: '{value} kgce'
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#f0f0f0",
                        },
                    },
                    
                    splitLine:{
                        show:false
                    }
                },
                {
                    type: 'value',
                    name:'%',
                    show:true,
                    min: 0,
                    max: 100,
                    // interval: 5,
                    axisLabel: {
                    textStyle: {
                        color: "#fff",
                    },
                    },
                    splitLine:{
                        show:false
                    }
                }
                ],
                series: [
                {
                    name: '今年',
                    type: 'bar',
                    tooltip: {
                    valueFormatter: function (value) {
                        return value + ' kgce';
                    }
                    },
                    data: [],
                    itemStyle: {
                        color: "#2291E3"
                    }
                },
                {
                    name: '去年',
                    type: 'bar',
                    tooltip: {
                    valueFormatter: function (value) {
                        return value + ' kgce';
                    }
                    },
                    data: [],
                    itemStyle: {
                        color: "#F6BD16"
                    }
                },
                {
                    name: '同比率',
                    type: 'line',
                    yAxisIndex: 1,
                    smooth:true,
                    showSymbol: false,
                    tooltip: {
                    valueFormatter: function (value) {
                        return value + ' %';
                    }
                    },
                    data: [],
                    itemStyle: {
                        color: "#E8684A"
                    }
                }
                ]
            },
            optionHuan:{ //图例配置
				legend: {
					top: 'bottom',
					icon: "roundRect",
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
						fontSize: 14,
						color:"#f0f0f0",
						borderWidth:0
					},
				},
				title: {
                    text: 'kWh',
                    x: '2%',
                    y: '-3%',
                    textStyle:{                  //标题样式
                        fontSize: '10',
                        fontFamily:'Source Han Sans CN',
                        color:'rgba(230,243,253, 0.7)',
                    }
                },
				grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '8%',
                    top:'10%',
                    containLabel: true
                },
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(0, 10, 26, 0.8)',
					borderRadius: 8,  
					borderWidth: 0,
					shadowColor:'rgba(13, 148, 255, 0.8)',
					axisPointer: {// 坐标轴指示器，坐标轴触发有效
						type: 'line', // 默认为直线，可选为：'line' | 'shadow'
					},
					textStyle: {
						color: '#fff'
					},
				},
				xAxis: { 
					type: 'category' ,
					axisLabel:{
						color: '#f0f0f0',
					}
					
					},
				yAxis: {
					splitLine:{
                        show:false
                    },
					axisLabel:{
						color: '#f4f4f4',
					}
				},
				dataset: {
					dimensions: ['product', '本期', '上期'],
					source: [{ product: '', '本期': 43.3, '上期': 85.8 }]
				},
				series: [
					{ type: 'bar' }, { type: 'bar' }
				]
			},  
            allArr:[[[],[],[]], [[],[],[]]], //水电同比数组
            currentArr:[], // 当前数组
            energyArr:[],// 环比数组 
        }
    },
    components:{
        Title,
        SelectList,
        Bar,
        charts,
        Graph
    },
    created(){
        this.xData = []
        for(let i = 0; i <= 24; i++){
            this.xData.push((i<10?'0'+i:i)+':00')
        }
    },
    mounted() {
        this.getEnergySequential()
        this.getEnergySequentialHuan()
        this.getWaterAir()
        window.addEventListener('resize',this.chartResize)
        window.addEventListener('beforeunload', this.clearChart);
    },
    methods:{
        tabdate(idx){
            this.dateIdx = idx
            let _this = this
            if(this.tabIdx == 0){
                this.$set(this.option.series[0], 'data', this.allArr[this.dateIdx][0])
                this.$set(this.option.series[1], 'data', this.allArr[this.dateIdx][1])
                this.$set(this.option.series[2], 'data', this.allArr[this.dateIdx][2])
                this.initCharts()
            }else {
                console.log('环比');
                let current = this.energyArr[this.dateIdx]

                this.$set(_this.optionHuan.dataset,'source',[{ 
                    product: '', 
                    '本期': Number(current[1]).toFixed(2), 
                    '上期': Number(current[0]).toFixed(2)
                }])
                this.initChartsHuan()
            }
        },
        tabTitle(idx){
            let _this = this
            this.tabIdx = idx
            // this.myChart = null;
            if(idx == 0){
                this.$set(this.option.series[0], 'data', this.allArr[this.dateIdx][0])
                this.$set(this.option.series[1], 'data', this.allArr[this.dateIdx][1])
                this.$set(this.option.series[2], 'data', this.allArr[this.dateIdx][2])
                this.initCharts()
            }else {
                console.log('环比');
                let current = this.energyArr[this.dateIdx]

                this.$set(_this.optionHuan.dataset,'source',[{ 
                    product: '', 
                    '本期': Number(current[1]).toFixed(2), 
                    '上期': Number(current[0]).toFixed(2)
                }])
                this.initChartsHuan()
            }
        },
        // 同比
        initCharts() {
            this.myChart = echarts.getInstanceByDom(document.getElementById("EnergyChain"));
            if(this.myChart == null){
                this.myChart = echarts.init(document.getElementById("EnergyChain"));
            }
            
            this.option && this.myChart.setOption(this.option);
        },
        clearChart(){
            // 手动触发 destroy 相关的生命周期
            this.$destroy();
        },
        chartResize(){
            let _this = this
            //防抖
            if(this.timer)
                clearTimeout(this.timer)
            this.timer = setTimeout(()=>{
                this.myChart.resize();
            },500)
        },
        // 能耗同比
        async getEnergySequential(){
            let that = this
            let time = getTodayTime()
            let month = new Date().getMonth() + 1
            let data = {
                date:`${time}T00:00:00Z`,
                powerType:'ELECTRICITY',
                projectId:this.$store.state.projectId
            }
            let res = await that.$http.energyCompareMonth(data)
            let result = res.data.data.data
            let year = new Array(12).fill(0)
            let lastYear = new Array(12).fill(0)
            let bi = new Array(12).fill(0)
            result.forEach((item,index) =>{
                year[index] = item[0].toFixed(2)
                lastYear[index] = item[1].toFixed(2)
                let b = item[1] == item[0]?0: item[0] == 0?100:(item[1] - item[0]) / item[0]
                bi[index] = b
            })
            this.allArr[0] = [lastYear.slice(0,month), year.slice(0,month), bi.slice(0,month)]

            this.tabdate(0)

        },
        async getWaterAir(){
            let that = this
            let time = getTodayTime()
            let month = new Date().getMonth() + 1
            let data = {
                date:`${time}T00:00:00Z`,
                powerType:'WATER',
                projectId:this.$store.state.projectId
            }
            let res = await that.$http.energyCompareMonth(data)
            let result = res.data.data.data
            let year = new Array(12).fill(0)
            let lastYear = new Array(12).fill(0)
            let bi = new Array(12).fill(0)
            result.forEach((item,index) =>{
                year[index] = item[0].toFixed(2)
                lastYear[index] = item[1].toFixed(2)
                let b = item[1] == item[0]?0: item[0] == 0?100:(item[1] - item[0]) / item[0]
                bi[index] = b
            })
            this.allArr[1] = [lastYear.slice(0,month), year.slice(0,month), bi.slice(0,month)]
        },
        // 环比数据
        initChartsHuan() {
			this.myChartHuan = echarts.getInstanceByDom(document.getElementById("EnergyRatio"));
			if(this.myChartHuan == null){
				this.myChartHuan = echarts.init(document.getElementById("EnergyRatio"));
			}
			this.optionHuan && this.myChartHuan.setOption(this.optionHuan);
			
		},
        // 能耗环比
		async getEnergySequentialHuan(){
			let time = getTodayTime()
			let that = this
			let dateArr = ['DAY', 'MONTH', 'YEAR']
			let data = {
				compareType:'SEPARATED',
				dateRange:dateArr[0],
				date:`${time}T00:00:00Z`,
				powerType:'ELECTRICITY',
				projectId:this.$store.state.projectId
			}
			let data1 = {
				compareType:'SEPARATED',
				dateRange:dateArr[0],
				date:`${time}T00:00:00Z`,
				powerType:'WATER',
				projectId:this.$store.state.projectId
			}
			let res = await Promise.all([that.$http.energyCompare(data), that.$http.energyCompare(data1)])
			let energyArr = res.map(item =>{
				return item = item.data.data.data[0]
			})
			this.energyArr = [energyArr[0], energyArr[1]]

		}
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.chartResize);
        window.removeEventListener('beforeunload', this.clearChart);
        if(!this.myChart) return 
        this.myChart.clear()
        this.myChart = null;
        this.myChartHuan.clear()
        this.myChartHuan = null;
    }
}
</script>

<style lang="less" scoped>
    
    .FoldingSandard{
        width: 20vw;
        position: fixed;
        top: 39vh;
        right: 2vw;
        z-index: 1;
        
        
        .echarts{
            overflow: hidden;
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            padding-top: 1vh;
            .tab{
                height: 14%;
                display: flex;
                color: rgba(230, 243, 253, 0.7);
                justify-content: space-evenly;
                align-items: center;
                align-content: space-evenly;
                flex-wrap: wrap;
                padding: 0 1vw;
                .report{
                    background: url("../../../../assets/img/btn3.png") no-repeat;
                    background-size: 100% 100%;
                    text-align: center;
                    height: 34rem;
                    line-height: 34rem;
                    font-size: 14rem;
                    width: 90rem;
                    cursor: pointer;
                }
                .se{
                    background: url("../../../../assets/img/btn4.png") no-repeat ;
                    background-size: 100% 100%;
                }
            }
            .tabdate{
                height: 14%;
                display: flex;
                color: rgba(230, 243, 253, 0.7);
                justify-content: space-evenly;
                align-items: center;
                align-content: space-evenly;
                flex-wrap: wrap;
                padding: 0 1vw;
                .report{
                    background: url("../../../../assets/img/btn1.png") no-repeat;
                    background-size: 100% 100%;
                    text-align: center;
                    height: 34rem;
                    line-height: 34rem;
                    font-size: 14rem;
                    padding:0 1vw ;
                    cursor: pointer;
                }
                .se{
                    background: url("../../../../assets/img/btn2.png") no-repeat ;
                    background-size: 100% 100%;
                }
            }
            .charts{
                height: 70%;
                padding: 2vh 0 1vh;
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>